<script lang="ts">
	// TODO(solar-setup): remove with classic PV wizard. Home Settings uses SolarSetupSettingsModal.
	import { get } from 'svelte/store';
	import { createEventDispatcher } from 'svelte';
	// Formating
	import { format } from 'svelte-i18n';
	//Design system components
	import {
		Button,
		Text,
		Modal,
		Wizard,
		WizardContainer,
		WizardContent,
		WizardItem,
	} from '@Shelly/shelly-design-system';
	//Helpers
	import { getPVSetupDevices, getPVSetupWizardItems, type PVSetupTypes } from './pv_setup_helper';
	import { home_data } from 'src/stores/account/user';
	import { save_home } from 'src/helpers/home_helpers';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';
	//Components
	import PvSetupTypeSelect from './PVSetupTypeSelect.svelte';
	import PVSetupSelectDevices from './PVSetupSelectDevices.svelte';

	export let showModal = false,
		type: PVSetupTypes;

	let waitForResponse = false;
	let wizardItems = getPVSetupWizardItems();
	let pvConfigStep = wizardItems[0];

	const dispatcher = createEventDispatcher();
	const save = async () => {
		waitForResponse = true;
		const pvConfigurations = get(home_data)?.pv_configurations || {};
		pvConfigurations[type] = {
			gridDevices: pVSetupDevices.gridDevices.map((dev) => {
				return dev.id;
			}),
			solarDevices: pVSetupDevices.solarDevices.map((dev) => {
				return dev.id;
			}),
		};
		const res = await save_home('pv_configurations', pvConfigurations);
		if (res?.isok) {
			showModal = false;
			dispatcher('save', type);
		} else {
			onSettingsResponse(res);
		}
		waitForResponse = false;
	};

	$: pVSetupDevices = getPVSetupDevices(type);
</script>

<Modal
	title={$format('modal_pv_setup_pv_configuration', {
		default: 'PV Configuration',
	})}
	{showModal}
	on:close={() => {
		showModal = false;
	}}
	removeScrollPadding
>
	<Wizard
		slot="toolbar"
		activeStepNumber={pvConfigStep.activeIndex}
		stepsTotal={wizardItems.length}
		activeStepTitle={pvConfigStep.title}
	>
		{#each wizardItems as item, i (i)}
			<WizardItem
				on:click={() => {
					pvConfigStep = wizardItems[i];
				}}
				active={pvConfigStep.activeIndex === i}
				title={item.title}
				disabled={i == 2 && !pVSetupDevices?.gridDevices?.length}
				indicatorColor={$showNewLayout ? 'color-2' : undefined}
			/>
		{/each}
	</Wizard>

	<div class:flex-overflow-hidden={false} slot="content">
		<WizardContainer activeStepIndex={pvConfigStep.activeIndex} adaptiveHeight={true}>
			{#each wizardItems as item, i (i)}
				<!-- DO NOT REMOVE COMMENT: Padding references -->
				<WizardContent active={pvConfigStep.activeIndex === i} class="pb-s">
					<Text element="h2" class="mb-s">
						{item.subtitle}
					</Text>
					{#if i == 0}
						<PvSetupTypeSelect bind:pvSetupType={type} />
					{:else if i == 1}
						<PVSetupSelectDevices
							{type}
							bind:selectedDevices={pVSetupDevices.gridDevices}
							excludedDevices={pVSetupDevices.solarDevices}
						/>
					{:else if i == 2}
						<PVSetupSelectDevices
							{type}
							pvCategory="solar"
							bind:selectedDevices={pVSetupDevices.solarDevices}
							excludedDevices={pVSetupDevices.gridDevices}
						/>
					{/if}
				</WizardContent>
			{/each}
		</WizardContainer>
	</div>
	<div slot="footer" class="d-flex justify-content-end">
		{#if pvConfigStep.activeIndex > 0}
			<Button
				class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap mr-s"
				icon="fas fa-chevron-left"
				responsiveSize={{
					sm: 'm',
				}}
				variant="secondary"
				on:click={() => {
					if (pvConfigStep.activeIndex > 0) {
						pvConfigStep = wizardItems[pvConfigStep.activeIndex - 1];
					}
				}}
			>
				{$format('button_back', { default: 'Back' })}
			</Button>
		{/if}
		<Button
			class="min-width-md-m min-width-sm-auto width-md-auto width-sm-full text-nowrap"
			icon={pvConfigStep.activeIndex == wizardItems.length - 1 ? 'fas fa-save' : ''}
			rightIcon={pvConfigStep.activeIndex == wizardItems.length - 1 ? '' : 'fas fa-chevron-right'}
			responsiveSize={{
				sm: 'm',
			}}
			loading={waitForResponse}
			disabled={(pvConfigStep.activeIndex == 1 && !pVSetupDevices?.gridDevices?.length) ||
				(pvConfigStep.activeIndex == 2 && !pVSetupDevices?.solarDevices?.length)}
			on:click={() => {
				if (pvConfigStep.activeIndex == wizardItems.length - 1) {
					save();
				} else {
					pvConfigStep = wizardItems[pvConfigStep.activeIndex + 1];
				}
			}}
		>
			{pvConfigStep.activeIndex == wizardItems.length - 1
				? $format('button_save', { default: 'Save' })
				: $format('button_next', { default: 'Next' })}
		</Button>
	</div>
</Modal>
